import { colorSchemeDark, type Theme, themeQuartz } from 'ag-grid-community';

import type { DarkStyle, ResolvedTheme } from '@/utils/theme';

// AG Grid draws its own chrome through the Theming API rather than the page's
// utility classes, so it can't pick midnight up from CSS -- the palette has to
// be handed to it. Values are the tokens midnight.css already defines, so the
// grid reads as part of the page instead of as AG Grid's generic dark scheme.
const MIDNIGHT_PARAMS = {
  backgroundColor: '#0d1117', // uniform-gray-900, the page itself
  foregroundColor: '#dae1e8', // uniform-gray-200 body ink, 14.34:1
  borderColor: '#232b35', // uniform-gray-700, the same rule weight Card uses
  chromeBackgroundColor: '#151b23', // uniform-gray-800, header and panel fill
  headerTextColor: '#bcc5cf', // uniform-gray-300
  accentColor: '#35c85f' // uniform-green-500
};

/**
 * Resolve the AG Grid theme for the current page theme. Classic dark gets AG
 * Grid's own dark scheme, matching the billing grids; midnight retunes that
 * scheme onto the midnight palette.
 */
export const resolveGridTheme = (
  resolvedTheme: ResolvedTheme,
  darkStyle: DarkStyle,
  base: Theme = themeQuartz
): Theme => {
  if (resolvedTheme !== 'dark') return base;

  const dark = base.withPart(colorSchemeDark);

  return darkStyle === 'midnight' ? dark.withParams(MIDNIGHT_PARAMS) : dark;
};

export default resolveGridTheme;
